import * as yup from "yup";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { HTTP_ENDPOINTS, QUERY_KEYS } from "../../consts/api";
import { http } from "../../services/HttpService";
import { removeNullishFromShape } from "../../utilities/general";

const requestSchema = yup.object({
  id: yup.number().nullable(),
  title: yup.string().required(),
  questions: yup
    .array()
    .of(
      yup.object({
        id: yup.number().nullable(),
        boxtype: yup.string().required(),
        description: yup.boolean().required(),
        descriptionText: yup.string().nullable(),
        displayOrder: yup.number().required(),
        name: yup.string().required(),
        options: yup.array().of(yup.string()).required(),
        required: yup.boolean().required(),
        why_choose: yup.boolean().required(),
      }),
    )
    .required(),
});

export const useCreateEditSurveyMutation = (options = {}) => {
  var queryClient = useQueryClient();

  return useMutation(
    async (dto) => {
      var req = requestSchema.validateSync(dto, {
        strict: true,
      });

      return await http.post(
        HTTP_ENDPOINTS.surveys.mutate(),
        removeNullishFromShape({
          sid: req.id,
          title: req.title,
          data: req.questions,
        }),
      );
    },
    {
      ...options,
      onSuccess: (...args) => {
        queryClient.invalidateQueries({
          queryKey: [QUERY_KEYS.surveys.one],
        });
        options.onSuccess?.(...args);
      },
    },
  );
};
